export default {
    VERIFY_OTP: "VERIFY_OTP",
}